<ng-template #field>
    <textarea
        [rows]="rows"
        class="form-control"
        [formControl]="form"
        [id]="id"
        [maxlength]="maxLength"
        [class.is-invalid]="ngControl.invalid && ngControl.touched"
        (blur)="onTouch?.()"></textarea>
    @if (ngControl.control != null) {
        <app-control-messages [control]="ngControl.control" />
    }
</ng-template>

@if (labelCols != null) {
    <div class="form-group row">
        <label class="col-form-label" [class]="labelClass" [for]="id">{{ label }}</label>
        <div [class]="inputColsClass">
            <ng-container [ngTemplateOutlet]="field" />
        </div>
    </div>
} @else {
    <div class="mb-3">
        @if (label.length > 0) {
            <div class="d-flex justify-content-between">
                <label class="form-label" [class]="labelClass" [for]="id">{{ label }}</label>
                @if (information) {
                    <app-popover-icon class="ms-3" [popover]="information" />
                }
            </div>
        }
        <ng-container [ngTemplateOutlet]="field" />
    </div>
}
